/**
 * @file SecurityRoleDefineTab.js
 * @description Step 1 of the security role wizard — name and description fields.
 */
import React from 'react';
import { getText } from '../../../i18n';

const SecurityRoleDefineTab = ({ data, onChange, readOnly }) => {
    const handleChange = e => {
        const { name, value } = e.target;
        onChange({ [name]: value });
    };

    return (
        <form
            onSubmit={e => e.preventDefault()}
            className="m-auto col-xs-12 col-sm-12 col-md-10 col-lg-8 px-4 py-5"
        >
            <div className="form-group mb-4">
                <label htmlFor="sr-name">
                    {getText('msg_709a23220f2c')}
                    <span className="text-danger ms-1">*</span>
                </label>
                <input
                    id="sr-name"
                    type="text"
                    name="name"
                    maxLength="50"
                    className="form-control mt-1"
                    value={data.name}
                    onChange={handleChange}
                    placeholder={getText('msg_61dca24f347f')}
                    disabled={readOnly}
                    required
                />
                <small className="form-text text-muted">
                    {`Character Limit ${data.name?.length ?? 0}/50`}
                </small>
            </div>

            <div className="form-group mb-4">
                <label htmlFor="sr-description">{getText('msg_55f8ebc805e6')}</label>
                <textarea
                    id="sr-description"
                    name="description"
                    maxLength="200"
                    rows="5"
                    className="form-control mt-1"
                    value={data.description}
                    onChange={handleChange}
                    placeholder={getText('msg_c00b8511fac3')}
                    disabled={readOnly}
                    style={{ resize: 'none' }}
                />
                <small className="form-text text-muted">
                    {`Character Limit ${data.description?.length ?? 0}/200`}
                </small>
            </div>
        </form>
    );
};

export default SecurityRoleDefineTab;
